export default __webpack_public_path__ + "img/about.hero.asset.b156156c.jpg";